/*
 * Sticky add-to-cart bar for the Vitamin D Gummies PDP.
 * Shows once the hero buy box scrolls out of view (mobile + desktop) and
 * submits the same product form used by the hero, so cart behavior stays
 * identical (AJAX cart drawer, analytics, etc.).
 */
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-pdp-sticky-atc]');
  if (!bar) return;

  const target = document.getElementById(bar.dataset.observeTarget);
  const mainForm = document.getElementById(bar.dataset.targetForm);
  const mainQtyInput = document.getElementById(bar.dataset.targetQtyInput);
  const stickyQtyInput = bar.querySelector('[data-sticky-qty]');
  const stickyPrice = bar.querySelector('[data-sticky-price]');
  const stickyMinus = bar.querySelector('[data-sticky-qty-minus]');
  const stickyPlus = bar.querySelector('[data-sticky-qty-plus]');
  const stickyAdd = bar.querySelector('[data-sticky-add]');

  if (target && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -15% 0px' }
    );
    observer.observe(target);
  }

  function syncQtyToMain() {
    if (mainQtyInput && stickyQtyInput) {
      mainQtyInput.value = stickyQtyInput.value;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (stickyMinus && stickyQtyInput) {
    stickyMinus.addEventListener('click', () => {
      const value = Math.max(1, parseInt(stickyQtyInput.value || '1', 10) - 1);
      stickyQtyInput.value = value;
      syncQtyToMain();
    });
  }

  if (stickyPlus && stickyQtyInput) {
    stickyPlus.addEventListener('click', () => {
      const value = parseInt(stickyQtyInput.value || '1', 10) + 1;
      stickyQtyInput.value = value;
      syncQtyToMain();
    });
  }

  if (stickyAdd) {
    stickyAdd.addEventListener('click', () => {
      syncQtyToMain();
      if (mainForm) mainForm.requestSubmit();
    });
  }

  document.addEventListener('pdp:bundle-select', (event) => {
    if (stickyPrice && event.detail && event.detail.priceHtml) {
      stickyPrice.innerHTML = event.detail.priceHtml;
    }
  });
});
